// Deprecated -- use CheckboxField.jsx
import React from 'react'

export default class Checkbox2 extends React.Component {
  handleChange = e => {
    const { id } = this.props
    this.props.handleChange(id, e.target.checked)
  }

  render() {
    const { id, label, value, labelStyle, disabled = false } = this.props

    return (
      <div className="checkbox2">
        <input
          type="checkbox"
          id={id}
          className="checkbox2-check"
          onChange={this.handleChange}
          value={value}
          checked={value}
          disabled={disabled}
        />
        <label htmlFor={id} className="checkbox2-tick">
          <span className="checkbox2-tick-circle" />
          <span className="checkbox2-tick-label" style={labelStyle}>
            {label}
          </span>
        </label>
      </div>
    )
  }
}
